import { createRouter, createWebHistory } from 'vue-router'
import store from '../store';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: {
        name: 'login'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
    },
    {
      path: '/account',
      name: 'account',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "Account" */ '../views/Account.vue')
    },
    {
      path: '/add-class',
      name: 'add-class',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "AddClass" */ '../views/AddClass.vue')
    },
    {
      path: '/classes',
      name: 'classes',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "AllClasses" */ '../views/AllClasses.vue')
    },
    {
      path: '/class-list',
      name: 'class-list',
      props: { routeIndex : 1 },
      component: () => import(/* webpackChunkName: "ClassList" */ '../views/ClassList.vue')
    },
    {
      path: '/start-session',
      name: 'start-session',
      props: { routeIndex : 6 },
      component: () => import(/* webpackChunkName: "StartSessionSettings" */ '../views/StartSessionSettings.vue')
    },
    {
      path: '/student-list/:name',
      name: 'student-list',
      props: { routeIndex : 2, name: true },
      component: () => import(/* webpackChunkName: "StudentList" */ '../views/StudentList.vue'),
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "Tutorial" */ '../views/Tutorial.vue')
    },
    {
      path: '/new-class',
      name: 'new-class',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "NewClass" */ '../views/NewClass.vue')
    },
    {
      path: '/class-info/:name',
      name: 'class-info',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "StudentListAdded" */ '../views/StudentListAdded.vue')
    },
    {
      path: '/new-session/:name',
      name: 'new-session',
      props: { routeIndex : 6 },
      component: () => import(/* webpackChunkName: "StartNewSession" */ '../views/StartNewSession.vue')
    },
    {
      path: '/start-session/:name',
      name: 'start-session',
      props: { routeIndex : 6 },
      component: () => import(/* webpackChunkName: "StartSession" */ '../views/StartSession.vue')
    },
    {
      path: '/edit-student-list/:name',
      name: 'edit-student-list',
      props: { routeIndex : 2 },
      component: () => import(/* webpackChunkName: "EditStudentList" */ '../views/EditStudentList.vue')
    },
    {
      path: '/dev',
      name: 'dev-login',
      component: () => import(/* webpackChunkName: "DevLogin" */ '../views/DevLogin.vue')
    },
    {
      path: '/past-sessions/:name',
      name: 'past-sessions',
      props: { routeIndex : 3 },
      component: () => import(/* webpackChunkName: "DevLogin" */ '../views/PastSessions.vue')
    },
    {
      path: '/session-analytics/:name/:session',
      name: 'session-analytics',
      props: { routeIndex : 4 },
      component: () => import(/* webpackChunkName: "DevLogin" */ '../views/SessionAnalytics.vue')
    },
    {
      path: '/session-analytics/:name',
      redirect: {
        name: 'past-sessions'
      }
    },
    {
      path: '/live-session/:name',
      name: 'live-session',
      props: { routeIndex : 6 },
      component: () => import(/* webpackChunkName: "DevLogin" */ '../views/LiveSession.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'login' || to.name === 'dev-login') {
    if (store.state.authenticated) {
      next({ name: 'class-list' });
    }
    else {
      next();
    }
  } else if (!store.state.authenticated) {
    next('/login');
  } else {
    next();
  }
  store.commit("UPDATE", false)
})

export default router